export const colgatePalmoliveTexts = {
  searchText: "Implementation & Platform User Experience (as applicable)",
  replaceText: "Implementation & Platform User Experience",
  hoverText:
    "Experience with implementation types, setup, and process for integrations (GIT). Usability and functionality executing use cases and action items within the platform (as applicable)",
};
